import React from 'react';
import { useDispatch } from 'react-redux';
import './DomainElements.scss';
import { showModalForDomainPart } from '../DomainModalGrid/actions';

/**
 * Domain components.
 * @param {Object} props - Object which contains all props of component.
 * @param {Function} props.getSelectedItemDetails - Send details of the clicked canbus component ,
 * @param {Object} props.domainData - Contains the metadata of domain components,
 * @param {Boolean} [props.disableClick] - Disabled button click functionality
 */
export default function DomainElements({
  getSelectedItemDetails,
  domainData,
  disableClick,
}) {
  const dispatch = useDispatch();
  return domainData.map((item) => {
    /** Source of component image */
    const domainComponentImageUrl = item.thumbPaths
      ? item.thumbPaths[item.status]
      : '';
    return domainComponentImageUrl ? (
      <img
        src={domainComponentImageUrl}
        className="domain-component-style"
        key={item.componentLabel}
        onClick={
          disableClick
            ? null
            : () => {
                getSelectedItemDetails(
                  item.componentData,
                  item.componentIdentifier,
                );
                dispatch(showModalForDomainPart(item.componentIdentifier));
              }
        }
        style={{ ...item.styles }}
        alt={item.componentLabel}
      />
    ) : null;
  });
}
